import type { SVGProps } from 'react';

const SvgArrowSmallE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m17.71 11.29-3-3A.996.996 0 1 0 13.3 9.7l1.29 1.29H7c-.55 0-1 .45-1 1s.45 1 1 1h7.59l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgArrowSmallE;
